import { object, string } from 'yup';
import { CreateCommand } from '../../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../../enums.js';

const SCHEMA = object({
  id: string().required(),
});

/**
 * MySpaceMyCardsUpdateEvent
 *
 * - Evento emitido quando um card é atualizado no meu espaço.
 */
export class MySpaceMyCardsUpdateEvent extends CreateCommand(RealtimeEventType.MySpaceMyCardsUpdate, SCHEMA) {}
